import axios from 'axios'
import _, { isEmpty } from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import { Button, Card, Col, Empty, message, Modal, Row, Upload } from 'antd'
import styled from 'styled-components'
import { styles } from './styles'
import { compressFile } from '../../../../utils/services'
import { getHeroDetail } from '../../../../modules/hero'
import { useDispatch } from 'react-redux'

const CloseButton = styled.span`
  position: absolute;
  top: -20px;
  right: 0px;
  z-index: 100;
  font-size: 40px;
  color: white;
  cursor: pointer;

  &:hover {
    color: red;
  }
`

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!')
  }
  return false
}

const Image = ({ data }) => {
  const dispatch = useDispatch()

  const handleUploadChange = async (info, type) => {
    // getBase64(info.file)
    const formData = new FormData()
    formData.append('image', await compressFile(info.file))

    if (type === 'idCard') {
      await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/hero/image-idcard`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data'
          },
          params: {
            heroId: data.id
          }
        }
      )
      await dispatch(getHeroDetail(data.id))
    } else if (type === 'document') {
      if (data.pictures.length !== 5) {
        await axios.post(
          `${process.env.REACT_APP_API_ENDPOINT}/hero/image-document`,
          formData,
          {
            headers: {
              'content-type': 'multipart/form-data'
            },
            params: {
              heroId: data.id
            }
          }
        )
        await dispatch(getHeroDetail(data.id))
      } else {
        Modal.warning({
          content: 'ไม่สามารถอัพโหลดได้เกิน 5 รูป'
        })
      }
    }
  }

  const handleDeleteImage = async (e, imageId) => {
    e.preventDefault()
    const token = localStorage.getItem('user-token')
    await axios.delete(
      `${process.env.REACT_APP_API_ENDPOINT}/hero/image-document`,
      {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: !_.isNull(token) ? token : ''
        },
        params: {
          heroId: data.id,
          imageId: imageId
        }
      }
    )
    await dispatch(getHeroDetail(data.id))
  }

  return (
    <React.Fragment>
      <Card
        style={{ marginTop: 16 }}
        cover={
          <div style={styles.avatarWraper}>
            <Row type="flex" justify="center">
              <Col>
                <Upload
                  name="avatar"
                  listType="picture-card"
                  showUploadList={false}
                  beforeUpload={beforeUpload}
                  onChange={(info) => handleUploadChange(info, 'idCard')}>
                  {!_.isNull(data.idCard) ? (
                    <img
                      src={data.idCard}
                      alt="avatar"
                      style={{ width: 500, height: 350 }}
                    />
                  ) : (
                    <Empty style={{ marginTop: 16 }} />
                  )}
                </Upload>
              </Col>
            </Row>
          </div>
        }>
        <Card.Meta title="ID Card" />
      </Card>

      <Card
        style={{ marginTop: 16 }}
        cover={
          !isEmpty(data.pictures) > 0 ? (
            <div>
              <Row style={{ marginBottom: 15 }}>
                {data.pictures.map((picture, index) => (
                  <Row key={picture.name}>
                    <Row
                      type="flex"
                      justify="center"
                      style={{ marginBottom: 5 }}>
                      <span
                        style={{
                          fontSize: 24
                        }}>{`รูปหน้าร้าน / รูปรถ / สถานที่ตั้ง ${
                          index + 1
                        }`}</span>
                    </Row>
                    <Row
                      type="flex"
                      justify="center"
                      style={{ marginBottom: 10 }}>
                      <div style={{ position: 'relative' }}>
                        <CloseButton
                          onClick={(e) => handleDeleteImage(e, picture.id)}>
                          &times;
                        </CloseButton>
                        <img
                          src={picture.url}
                          alt="avatar"
                          style={{ width: 500, height: 350 }}
                        />
                      </div>
                    </Row>
                  </Row>
                ))}
              </Row>
              <Row type="flex" justify="center">
                <Upload
                  showUploadList={false}
                  beforeUpload={beforeUpload}
                  onChange={(info) => handleUploadChange(info, 'document')}>
                  <Button>Click to Upload</Button>
                </Upload>
              </Row>
            </div>
          ) : (
            <div>
              <Row type="flex" justify="center" style={{ marginTop: 16 }}>
                <Col>
                  <Upload
                    listType="picture-card"
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    onChange={(info) => handleUploadChange(info, 'document')}>
                    <Empty />
                  </Upload>
                </Col>
              </Row>
            </div>
          )
        }>
        <Card.Meta title="Pictures" />
      </Card>
    </React.Fragment>
  )
}

Image.propTypes = {
  data: PropTypes.object.isRequired
}

export default Image



// WEBPACK FOOTER //
// ./src/pages/Heroes/components/Image/index.js